var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_3725_7019)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1736 4.79932L12.0781 5.11576V14.2973L12.1736 14.3902L16.5432 11.871L12.1736 4.79932Z",
    fill: "#C1CCF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 4.79932L7.79688 11.871L12.1665 14.3902V9.93378V4.79932Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.171 15.1966L12.1172 15.2607V18.5313L12.171 18.6845L16.5432 12.6787L12.171 15.1966Z",
    fill: "#C1CCF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 18.6845V15.1966L7.79688 12.6787L12.1665 18.6845Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 14.3901L16.5414 11.8708L12.1719 9.93359V14.3901Z",
    fill: "#8197EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 11.8708L12.1665 14.3901V9.93359L7.79688 11.8708Z",
    fill: "#C1CCF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3725_7019",
    x1: 24,
    y1: 24,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627EEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthActive);
export default __webpack_public_path__ + "static/media/ethActive.24d9e4a2122f5860154469fb6acd6f9b.svg";
export { ForwardRef as ReactComponent };